import { redirect } from "@bigyellow/libs/redirect";
import { getStoreMyAccountUrlByStoreName, setActiveAccount, setActiveStore } from "@bigyellow/libs/customer";
import { CHECKIN } from "@bigyellow/routes";
import { useEffect, useState } from "react";
import { store__get } from "@bigyellow/api/customer";
import { withStore } from "@bigyellow/store";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DashboardMoveInDetails } from "@bigyellow/components/Store/MoveInDate/DashboardMoveInDetails";


export const StoreImage = ({store}) => {
    // const storeName = store.name.toLowerCase().replaceAll(" ", "-"); // ES12 (2021)
    const storeName = store.name.toLowerCase().replace(/ /g, "-"); // TODO: Quick Fix, look at using polyfill.
    const location = window.location.origin.indexOf('127') > 0 ? 'https://dev.bigyellow.co.uk' : window.location.origin;
    const imgSrc = `${location}/assets/images/stores/square/${storeName}.jpg`;

    return (
        <picture>
            <img src={imgSrc} className={`img-fluid`} alt={`Store photo`}/>
        </picture>
    )
}


const StoreItem = ({account, store, textonly}) => {
    
    const [loading, setLoading] = useState(true);
    const [item, setItem] = useState();
    
    const switchStore = (item) => {
        setActiveStore(item).then(() => {
            setActiveAccount(account).then(() => {
                if(account?.canCheckInOnline) {
                    redirect(CHECKIN);
                }else {
                    redirect(getStoreMyAccountUrlByStoreName(item.name));
                }
            })
        });
    }

    useEffect(async () => {
        
        const http_client = store.get('http_client');
        
        store__get(http_client, {
            storeId: account.storeId
        }).then(res => {
            setItem(res.data.data[0])
        })
        
        setLoading(false);
        
    }, [])
    
    if (loading || !item) {
        return <></>
    }

    if (textonly) {
        return (
          <>
              <div className={`nav-link`} onClick={() => switchStore(item)}>
                  <div className={`row m-0`}>
                      <div className={`title m-0`}>{item.name}</div>
                  </div>
              </div>
          </>
        )
    }

    const canChangeMoveInDate = account.hasReservation&& account?.reservations?.length>0

    return (
        <>

            <div className={`card store-card my-5 `} >
                <div className={`row m-0 p-2`} onClick={() => switchStore(item)}>
                    <div className={`p-3`}>
                        <StoreImage store={item}/>
                    </div>
                    <div className={`card-body py-3 px-1 d-flex flex-column align-items-start`}>
                        <h4 className={`m-0`}>{item.name}</h4>
                        {(account.hasActiveContract || account.hasReservation) && (
                            <div className={`room-numbers text-xs mb-2`}>
                                Room no. {account && account.roomNumbers.join('; ')}
                            </div>
                        )}
                        <span className={`checkin-status badge badge-${account.content.style} my-1`}>{account.content.statusText} </span>
                        <div className={` text-xs my-1`}>
                            <a href={"mailto:" + item.email}>{item.email}</a>
                        </div>
                        <div className={`text-xs`}>
                            <a href={"tel:" + item.phone}>{item.phone}</a>
                        </div>
                        <div className={`text-xs align-self-end mt-auto`}>
                        {account.content.ctaText}
                                    <span className={`btn-go text-xs m-1`}><FontAwesomeIcon icon="chevron-right" /></span>
                                </div>
                    </div>
                </div>
                {canChangeMoveInDate&&
                    <DashboardMoveInDetails account={account} activeStore={item}/>
                }
            </div>

        </>
    )
}

export default withStore(StoreItem);
